<template>
	<div class="subscribeVideo sticky" :class="{ moveUp: showAtTop}">
		<div ref="subscribe-video" />
		<span class="e-icons videoArrow" @click="onArrowClick" />
		<span class="e-icons fullScreen" @click="$emit(`fullScreen`)" />
		<div
			class="expandIcon"
			@click="toggleVideo();"
		/>
		<div class="nameContainer">
			<span class="notaryName">{{ notaryName.value }}</span>
			<span 				
				v-for="signer in principalSigners" 
				:key="signer.notarizationSignerId"
				class="clientName"
			>
				{{ signer.firstName }} {{ signer.lastName }}
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	inject: {
		notaryName: {type: String },
		openTokClientStreamReady: { type: Boolean },
		subscribeClientStream: { type: Function },
		isMuted: { type: Boolean },
		toggleMute: { type: Function },
		expandVid: { type: Boolean },
		toggleVideo: { type: Function },
		changeSubscribeTasksCount: { type: Function }
	},
	emits: [`fullScreen`],
	data() {
		return {
			showAtTop: false
		};
	},
	computed: {
		...mapGetters(`Signers`, [`principalSigners`, `witnesses`]),
	},
	watch: {
		'openTokClientStreamReady.value': {
			handler() {
				this.subscribe();
			},
			flush: `post`,
			immediate: true
		}
	},
	beforeMount() {
		this.changeSubscribeTasksCount();
	},
	unmounted() {
		this.changeSubscribeTasksCount(-1);
	},
	methods: {
		subscribe() {
			if (this.openTokClientStreamReady.value) {
				this.subscribeClientStream(this.$refs[`subscribe-video`]);
			}
		},
		onArrowClick() {
			this.showAtTop = !this.showAtTop;
		}
	},
};
</script>